module.exports = __webpack_public_path__ + "img/iphone-charging-POLAND-en.87414914.png";